import { createTheme as createLegacyTheme } from '@material-ui/core/styles';
import { createTheme } from '@mui/material';

import { darken, lighten } from './services/colors/colors';

export const themeColors = {
  primary: {
    MAIN: '#303d4a',
    DARK: '#192026',
    WHITE: '#ffffff',
  },
  secondary: {
    MAIN: '#fc2220',
    DARK: '#ca0f0f',
  },
  orange: '#FF7B1E',
  greyLight: '#8E8E8E',
  greyExtralight: '#ebebeb',
  greyExtraExtralight: '#f2f2f2',
  greyDark: '#707070',
  success: '#4DBD74',
  error: '#FB3C3A',
  optimhome: {
    MAIN: '#ff7b1e',
    OPTIMUST: '#FDFD00',
    DARK: '#ee731d',
    SECONDARY: '#FF5C02',
    PRESTIGE: '#BD481E',
  },
  capifrance: {
    MAIN: '#0093F7',
    DARK: '#082E4F',
    SECONDARY: '#0093F7',
  },
  digitregroup: {
    MAIN: '#0093F7',
    LIGHT: '#105983',
    DARK: '#082E4F',
  },
  viager: {
    MAIN: '#303D4A',
    SECONDARY: '#FF7B1E',
  },
  reflex: {
    MAIN: '#F96854',
    DARK: '#1c3765',
  },
  drimki: {
    MAIN: '#20c063',
  },
  dili: {
    MAIN: '#00cb99',
  },
  toutvabiens: {
    MAIN: '#2500b7',
  },
  white: '#ffffff',
};

const themeObject = {
  typography: {
    fontFamily: '"Source Sans Pro", "Helvetica", "Arial", sans-serif',
    lineHeight: 1,
    fontSize: 13,
    button: {
      textTransform: 'initial',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: 'none',
      },
    },
    MuiTab: {
      root: {
        fontWeight: 'bold',
        color: themeColors.primary.DARK,
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: themeColors.primary.WHITE,
        borderBottom: '1px solid',
        borderBottomColor: themeColors.greyExtraExtralight,
      },
      indicator: {
        backgroundColor: themeColors.primary.WHITE,
        borderBottom: '2px solid',
        borderBottomColor: themeColors.orange,
      },
    },
    MuiOutlinedInput: {
      inputMarginDense: {
        paddingBottom: '8.5px !important',
        paddingTop: '8.5px !important',
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        padding: '2px !important',
      },
    },
    MuiButton: {
      contained: {
        boxShadow: 'none !important',
      },
    },
  },
  palette: {
    mode: 'light',
    primary: {
      light: themeColors.primary.WHITE,
      main: themeColors.primary.MAIN,
      dark: themeColors.primary.DARK,
    },
    secondary: {
      light: themeColors.primary.WHITE,
      main: themeColors.secondary.MAIN,
      dark: themeColors.secondary.DARK,
      contrastText: themeColors.primary.WHITE,
      disabled: '#C6C6C6',
    },
    capifrance: {
      main: themeColors.capifrance.MAIN,
      light: lighten(themeColors.capifrance.MAIN, 20),
      dark: darken(themeColors.capifrance.MAIN, 20),
      font: lighten(themeColors.capifrance.MAIN, 80),
      fontDark: darken(themeColors.capifrance.MAIN, 60),
      mainButton: themeColors.capifrance.MAIN,
      danger: '#E8F5FF',
    },
    optimhome: {
      main: themeColors.optimhome.MAIN,
      light: lighten(themeColors.optimhome.MAIN, 20),
      dark: darken(themeColors.optimhome.MAIN, 20),
      font: lighten(themeColors.optimhome.MAIN, 80),
      fontDark: darken(themeColors.optimhome.MAIN, 60),
      mainButton: themeColors.optimhome.SECONDARY,
      prestige: themeColors.optimhome.PRESTIGE,
      danger: '#FCE9E6',
    },
    digitregroup: {
      main: themeColors.digitregroup.MAIN,
      light: themeColors.digitregroup.LIGHT,
    },
    refleximmo: {
      main: themeColors.reflex.MAIN,
    },
    drimki: {
      main: themeColors.drimki.MAIN,
    },
    immobilier_neuf: {
      main: themeColors.digitregroup.MAIN,
    },
    dili: {
      main: themeColors.dili.MAIN,
    },
    digitre_academy: {
      main: themeColors.digitregroup.MAIN,
    },
    viager: {
      main: themeColors.viager.MAIN,
      secondary: themeColors.viager.SECONDARY,
      contrastText: themeColors.primary.WHITE,
    },
    extraLightGray: themeColors.greyExtraExtralight,
    lightGrey: themeColors.greyExtralight,
    darkGrey: themeColors.greyDark,
    neutralGrey: themeColors.greyLight,
    textSuccess: themeColors.success,
    textError: themeColors.error,
  },
};

export const legacyTheme = createLegacyTheme(themeObject);

export const theme = createTheme(themeObject);
